module.exports = __webpack_public_path__ + "static/media/perfect-gold_00007.15e42f73.png";